import { BaseComponent, IStateBase } from 'components/BaseComponent';
import React from 'react';
import UserForm from './UserForm';
import Payment from './Payment';
import { SvgIcon } from 'components/SvgIcon';
import { paymentService } from 'services/PaymentService';
import { ICartModel } from 'interfaces/ICartModel';
import Button from '@material-ui/core/Button/Button';
import { cartService } from 'services/CartService';
import { IProductData, IProductConfig } from 'interfaces/IProductData';
import Translate from 'components/Translate';
import { MAX_CREDIT_CARDS } from 'settings';
import CpfForm from './Payment/PaymentForm/CpfForm/index';
import AlertComponent from 'components/AlertComponent';
import Snackbar from '@material-ui/core/Snackbar';
import Fade from '@material-ui/core/Fade';
import UserAddressForm from 'components/UserAddressForm';
import { FieldValidation } from 'components/Field';
import get from 'lodash/get';
import AcceptTerms from 'components/AcceptTerms';
import { enPaymentType } from 'enums/enPaymentType';
import { parameterService } from 'services/ParameterService';
import { validate } from 'validators';
import { enParameters } from 'enums/enParameters';
import QuantityForm from 'components/Cart/Physical/QuantityForm';
import PaymentButton from 'components/Cart/PaymentButton';

const styles = require('./mainForm.css');

interface IState extends IStateBase {
  model: ICartModel;
  cart: IProductData;
  config: IProductConfig;
  payment: ICartModel;
  showMessage: boolean;
  snackMessage: string;
  messageButton: string;
  showPaymentMultipleCardsButton: boolean;
  isValidParamterToSkip: boolean;
}

export default class MainForm extends BaseComponent<IState> {

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
    this.observeState({ config: null }, cartService.getConfig());
    this.observeState({ payment: null }, paymentService.getCart());
    this.observeState({ showPaymentMultipleCardsButton: false }, paymentService.showPaymentMultipleCardsButton());
    this.bindModel(paymentService.getCart());

    parameterService.getAll()
      .bindComponent(this)
      .filter((params) => !!params.skip)
      .filter((params) => validate(params.name || params.nome, 'required|name|max:100').valid)
      .filter((params) => validate(params.email, 'required|email|max:150').valid)
      .filter((params) => validate(params.phone || params.cel, 'required|min:10|max:11').valid)
      .do((params) => {
        paymentService.setData({
          name: params.name || params.nome,
          email: params.email,
          phone: params.phone || params.cel,
        });
      })
      .switchMap(() => parameterService.get(enParameters.skip))
      .filter((skip) => !!skip)
      .bindComponent(this)
      .subscribe(() => {
        this.setState({
          isValidParamterToSkip: true
        });
      });

    paymentService
      .getCart()
      .combineLatest(cartService.getCart(), cartService.getConfig())
      .bindComponent(this)
      .subscribe(([payment, cart, config]) => {
        this.changeMessageButton(payment, cart, config);
      });

    this.setState({
      showMessage: false
    });

  }

  addCreditCard = () => {
    paymentService.addPayment()
      .bindComponent(this)
      .take(1)
      .subscribe(res => {
        this.setState({
          showMessage: true,
          snackMessage: 'Um novo cartão foi adicionado'
        });
      });
  }

  showAddCardButton = () => {
    const isMultipleCreditCards = this.state.cart.config.multipleCreditCards;
    const canAddCreditCard = this.state.model.payment.length < MAX_CREDIT_CARDS && this.state.model.payment.length > 1;

    return isMultipleCreditCards && canAddCreditCard;
  }

  handleClose = () => {
    this.setState({
      showMessage: false
    });
  }

  removeCreditCard = () => {
    this.setState({
      showMessage: true,
      snackMessage: 'O cartão foi removido'
    });
  }

  finish = async () => {
    if (await this.isFormValid()) {
      this.props.onPay();
    }
  }
  isValid(): boolean {
    const validation = this.state.validation || {};
    return Object.keys(validation).length === 0;
  }

  changeMessageButton = (payment: ICartModel, cart: IProductData, config: IProductConfig) => {
    if (cart.paymentType == enPaymentType.FREE) {
      this.setState({ messageButton: 'Obter Gratuitamente' });
      return;
    }

    if (cart.paymentType == enPaymentType.SUBSCRIPTION) {
      this.setState({ messageButton: 'Assinar Plano' });
      return;
    }

    if (payment.payment[0].paymentMethod == null || payment.payment.length > 1) {
      const messageButton = get(config, 'template.styles.buttons.text', 'Pagar e Receber Agora');
      messageButton ? this.setState({ messageButton }) : this.setState({ messageButton: 'Pagar e Receber Agora' });
    } else {
      switch (payment.payment[0].paymentMethod) {
        case 'boleto':
          this.setState({ messageButton: 'Gerar Boleto' });
          break;
        case 'paypal':
          this.setState({ messageButton: 'Ir para o PayPal' });
          break;

        default:
          const messageButton = get(config, 'template.styles.buttons.text', 'Pagar e Receber Agora');
          messageButton ? this.setState({ messageButton }) : this.setState({ messageButton: 'Pagar e Receber Agora' });
      }
    }
  }

  render() {

    if (!this.state) {
      return <div />;
    }

    const { model, cart, config, messageButton, showPaymentMultipleCardsButton, isValidParamterToSkip } = this.state;
    return (
      <div className={styles.component}>
        <FieldValidation.Provider value={this.registerFields}>
          {
            !isValidParamterToSkip ?
              <UserForm />
              : null
          }

          {config.askAddressBeforePayment
            ? <UserAddressForm />
            : ''
          }

          {cart.pins ?
            <QuantityForm isPin={!!cart.pins} />
            : null
          }

          {cart.paymentType != enPaymentType.FREE ?
            <div className={'cpf-form'}>
              <CpfForm />
            </div>
            : null}
          {
            !isValidParamterToSkip ?
              <div className='chk-security-message' id='security-message-label'>
                <SvgIcon name='security' />
                <Translate term='Seus dados serão mantidos em sigilo' />
              </div>
              : null
          }

          {showPaymentMultipleCardsButton
            ? <Fade in={showPaymentMultipleCardsButton}>
              <div className='chk-multiple-cards'>
                <Button
                  id='chk-multiplecard-button'
                  className={'chk-add-credit-card theme-button'}
                  onClick={this.addCreditCard}
                >
                  <SvgIcon name='multipleCards' />
                  <Translate term='Pagar com múltiplos cartões?' />
                </Button>
              </div>
            </Fade>
            : null
          }

          {
            cart.paymentType == enPaymentType.FREE
              ? ''
              : model.payment.map((model, key) =>
                <Payment key={key} index={key} removeCreditCard={this.removeCreditCard} hidePaymentMessage={false} />
              )
          }

          {
            this.showAddCardButton()
              ? <div className='chk-multiple-cards'>
                <Button
                  id='chk-addcard-button'
                  className={'chk-add-credit-card add theme-button'}
                  onClick={this.addCreditCard}
                >
                  <SvgIcon name='plus' />
                  <Translate term='Adicionar cartão de pagamento' />
                </Button>
              </div>
              : ''
          }

          {cart.paymentType == enPaymentType.SUBSCRIPTION ?
            <AcceptTerms />
            : null
          }

          <div className='chk-submit'>

            <PaymentButton
              finish={this.finish}
              disabledButton={!this.isValid && this.state.formSubmitted}
              messageButton={messageButton}
              singleStep={true}
            />
          </div>

          <div className='chk-security-badges' id='chk-security-bedges'>
            <div>
              <SvgIcon name='security_check' />

              <div className='text'>
                <span className='buy'><Translate term={'Compra'} /></span>
                <span className='safety'><Translate term={'100% Segura'} /></span>
              </div>
            </div>

            <div>
              <SvgIcon name='security_finger' />

              <div className='text'>
                <span className='buy'><Translate term='Privacidade' /></span>
                <span className='safety'><Translate term='Protegida' /></span>
              </div>
            </div>

            <div>
              <SvgIcon name='safeHostIcon' />

              <div className='text'>
                <span className='buy'>GoDaddy ®</span>
                <span className='safety'>
                  <a
                    id='chk-godaddy'
                    href='https://seal.godaddy.com//verifySeal?sealID=ouL8MfhmoQ4juRhF5T4nzZnEC8g5QGxOM2VEfORRFBf4xBhAGt'
                    target='_blank'
                  >
                    <Translate term='Verificado e protegido' />
                  </a>
                </span>
              </div>
            </div>

            <AlertComponent />

            <Snackbar
              id='chk-card-message'
              className={'card-message'}
              open={this.state.showMessage}
              onClose={this.handleClose}
              autoHideDuration={3000}
              message={<span>{<Translate term={this.state.snackMessage} />}</span>}
            />
          </div>
        </FieldValidation.Provider>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/MainForm/index.tsx